/**
 * Derived from the discount's start/end window rather than stored, so it can
 * never go stale. Shared by the repo and the admin UI so the two agree.
 */
export enum SuppliesDiscountStatus {
  Scheduled = "scheduled",
  Active = "active",
  Expired = "expired",
}

/** The status a discount presents at `now`, from its window alone. */
export function deriveSuppliesDiscountStatus(
  startsAt: Date,
  endsAt: Date | null,
  now: Date,
): SuppliesDiscountStatus {
  if (startsAt.getTime() > now.getTime()) {
    return SuppliesDiscountStatus.Scheduled;
  }
  if (endsAt !== null && endsAt.getTime() <= now.getTime()) {
    return SuppliesDiscountStatus.Expired;
  }
  return SuppliesDiscountStatus.Active;
}
